import { render } from "./Page31.vue?vue&type=template&id=74d578d9"
import script from "./Page31.vue?vue&type=script&lang=js"
export * from "./Page31.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__